export default __webpack_public_path__ + "static/Roc-Grotesk-ExtraBold-ab47aa58b5666124413a6fdb4f92f446.otf";